var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tabs',{attrs:{"default-active-key":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"课堂作业"}},[_vm._v(" 暂无已批改作业哦～ ")]),_c('a-tab-pane',{key:"2",attrs:{"tab":"自定义作业"}},[_vm._v(" 暂无已批改作业哦～ ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }